import React, { useState, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import isBrowser from 'is-browser';

import {
  StyledPositionWrapper,
  StyledStickyHeader,
  StyledStickyHeaderContainer,
} from './styles';
import { headerData } from '../../store/local-storage';
import { StickyHeaderContext } from '../../hooks/use-sticky-header';
import { DividerBox } from '../Box/styles';
import { useWidth } from '../../hooks/use-width';

interface StickyHeaderProps {
  bottomShadow?: boolean;
  children?: React.ReactNode;
  noPadding?: boolean;
  onChangeToggle?: (value: boolean) => void;
}

export const StickyHeader: React.FC<StickyHeaderProps> = ({
  bottomShadow,
  children,
  noPadding,
  onChangeToggle,
}) => {
  const [toggle, setToggle] = useState(true);
  const initScroll = isBrowser ? window.scrollY : 0;
  const [scrollOffset, setScrollOffset] = useState(initScroll);
  const { activeModal } = useReactiveVar(headerData);
  const width = useWidth();

  useEffect(() => {
    onChangeToggle?.(toggle);
  }, [toggle]);

  useEffect(() => {
    if (isBrowser) {
      const handleScroll = () => {
        const { scrollY } = window;
        setScrollOffset(scrollY);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
    return;
  }, []);

  useEffect(() => {
    setToggle(scrollOffset < 135);
  }, [scrollOffset]);

  return (
    <StyledStickyHeaderContainer
      active={toggle}
      activeModal={activeModal}
      bottomShadow={bottomShadow}
      className='sticky-header-container'
    >
      <StyledPositionWrapper
        id='sticky-position'
        className={'sticky-header-position'}
        active={toggle}
        noPadding={noPadding}
        activeModal={activeModal}
      >
        <StyledStickyHeader
          className={`sticky-header-scroll ${!toggle && 'hidden'} up`}
          active={toggle}
          activeModal={activeModal}
          width={width}
        >
          <StickyHeaderContext.Provider
            value={{ isSticky: !toggle, isScrollDirectionUp: false }}
          >
            {children}
          </StickyHeaderContext.Provider>
        </StyledStickyHeader>
      </StyledPositionWrapper>
      <DividerBox style={{ marginTop: '16px' }} />
    </StyledStickyHeaderContainer>
  );
};
